import { useState, useCallback } from 'react';
import api from '../../utils/api';

export function useFarmerData(farmerId) {

  const [myAnimals,   setMyAnimals]   = useState([]);
  const [myOrders,    setMyOrders]    = useState([]);
  const [myInquiries, setMyInquiries] = useState([]);
  const [stats,       setStats]       = useState({
    totalListings:   0,
    activeListings:  0,
    pendingListings: 0,
    totalRevenue:    0,
    totalOrders:     0,
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const fetchMyAnimals = useCallback(async () => {
    if (!farmerId) return;
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/api/farmer/animals');
      setMyAnimals(data);
      setStats(prev => ({
        ...prev,
        totalListings:   data.length,
        activeListings:  data.filter(a => a.status === 'active').length,
        pendingListings: data.filter(a => a.status === 'pending').length,
      }));
    } catch {
      setError('Could not load your listings.');
    } finally { setLoading(false); }
  }, [farmerId]);

  const fetchMyOrders = useCallback(async () => {
    if (!farmerId) return;
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/api/farmer/orders');
      setMyOrders(data);
      const revenue = data
        .filter(o => o.status === 'completed')
        .reduce((sum, o) => sum + Number(o.amount || 0), 0);
      setStats(prev => ({
        ...prev,
        totalRevenue: revenue,
        totalOrders:  data.length,
      }));
    } catch {
      setError('Could not load your orders.');
    } finally { setLoading(false); }
  }, [farmerId]);

  const fetchMyInquiries = useCallback(async () => {
    if (!farmerId) return;
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/api/farmer/inquiries');
      setMyInquiries(data);
    } catch {
      setError('Could not load inquiries.');
    } finally { setLoading(false); }
  }, [farmerId]);

  const addAnimal = async (formData) => {
    try {
      const { data } = await api.post('/api/farmer/animals', formData);

      await fetchMyAnimals();
      return data;
    } catch (err) {
      console.error('addAnimal failed:', err.response?.data || err.message);
      throw err;
    }
  };

  const replyToInquiry = async (id, reply) => {
    await api.post(`/api/farmer/inquiries/${id}/reply`, { reply });
    setMyInquiries(prev =>
      prev.map(q => q.id === id ? { ...q, reply, status: 'replied' } : q)
    );
  };

  return {
    myAnimals, myOrders, myInquiries, stats, loading, error,
    fetchMyAnimals, fetchMyOrders, fetchMyInquiries,
    addAnimal, replyToInquiry, setMyOrders,
  };
}